import styled, { useTheme } from 'styled-components';

import RoundBtn from '../../Button/RoundBtn';

type ExitConfirmBodyProps = {
  title: string;
  contents: string | JSX.Element;
  cancelExit: () => void;
  confirmExit: () => void;
};
export default function ExitConfirmBody({ title, contents, cancelExit, confirmExit }: ExitConfirmBodyProps) {
  const theme = useTheme();
  return (
    <SModalWrapper>
      <SModalBody>
        <h3 className="title">{title}</h3>
        <div className="contents">{contents}</div>
      </SModalBody>
      <SModalFooter>
        <SCancelButton
          design="gray"
          onClick={cancelExit}
          radius="8px"
          style={{
            border: `1px solid ${theme.color.popup.btn_disable}`,
          }}
        >
          취소
        </SCancelButton>
        <SExitButton design="filled" onClick={confirmExit} radius="8px">
          나가기
        </SExitButton>
      </SModalFooter>
    </SModalWrapper>
  );
}

const SModalWrapper = styled.section`
  padding: 20px 24px 30px;
`;

const SModalBody = styled.div`
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;

  .title {
    ${({ theme }) => theme.font.head5_sb};
    color: ${({ theme }) => theme.color.text.default};
  }

  .contents {
    ${({ theme }) => theme.font.body2_r};
    color: ${({ theme }) => theme.color.text.TXT_3};
  }
`;

const SModalFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const SCancelButton = styled(RoundBtn)`
  height: 50px;
  width: 120px;
`;

const SExitButton = styled(RoundBtn)`
  height: 50px;
  width: 190px;
`;
